import styled from 'styled-components';



export const VerticalSpacer = styled.div`
    height: ${props => props.theme.space[props.space]};
    content: "\00a0";
`;

export default styled.span`
    width: ${props => props.theme.space[props.space]};
    content: "\00a0";
    display: inline-block;
`;



// WEBPACK FOOTER //
// ./src/components/styles/Spacer.js